export const THERAPY_STATISTICS_GRAPH_COLOR = '#82ca9d';
export const EXAM_STATISTICS_GRAPH_COLOR = '#8884d8';

export const PRIMARY_COLOR = '#4caf50'
export const SECONDARY_COLOR = '#000'
